import React from "react"
import PropTypes from "prop-types"
import { SortableContainer, SortableElement, arrayMove } from "react-sortable-hoc"
import Checkbox from "./Checkbox"

var deepcopy = require("deepcopy")

const SortableItem = SortableElement(({ index, value, onToggle, checked }) => (
    <li onClick={onToggle} className={"sortable-fields-item " + (checked ? "selected" : "")}>
        <span className="icon-drag-handle">
            <i className="icon-drag-handle" />
        </span>
        <span className="selected-indicator">
            <Checkbox value={checked} onChange={onToggle} />
        </span>
        {value}
    </li>
))

const SortableList = SortableContainer(({ items, onToggle }) => {
    return (
        <ul className="sortable-fields">
            {items.map((value, index) => (
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    value={value ? value.label : ""}
                    onToggle={() => onToggle(index)}
                    checked={value.isSelected}
                />
            ))}
        </ul>
    )
})

export default class SortablePicker extends React.Component {
    render() {
        return (
            <SortableList
                items={this.getFieldOptions()}
                onSortEnd={this.onSortEnd.bind(this)}
                onToggle={this.onToggleSelected.bind(this)}
                distance={10}
            />
        )
    }

    getValues() {
        let values = this.props.values
        if (!values.length) {
            // If none are selected, select them all
            values = this.getFields().map(field => field._sid)
        }
        return values
    }

    getFields() {
        return deepcopy(this.props.fields || [])
    }

    getFieldOptions() {
        let options = this.getFields()
            .sort(this.compareFields.bind(this))
            .map(field => {
                let isSelected = this.getValues().indexOf(field._sid) !== -1
                return { ...field, isSelected: isSelected }
            })
        return options
    }

    compareFields(a, b) {
        let values = this.getValues()
        let aIndex = values.indexOf(a._sid)
        let bIndex = values.indexOf(b._sid)
        if (aIndex === -1) return 1
        if (bIndex === -1) return -1
        if (aIndex === bIndex) return 0
        return aIndex < bIndex ? -1 : 1
    }

    onToggleSelected(index) {
        let items = this.getFieldOptions()
        let item = items[index]
        item.isSelected = !item.isSelected
        let values = items.filter(item => item.isSelected).map(item => item._sid)
        this.props.onChange(values)
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        let items = this.getFieldOptions()
        items[oldIndex].isSelected = true
        // debugger;
        let values = arrayMove(items, oldIndex, newIndex)
        values = values.filter(item => item.isSelected).map(item => item._sid)
        this.props.onChange(values)
    }
}

SortablePicker.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.object).isRequired, // The fields that are the options
    values: PropTypes.arrayOf(PropTypes.string), // returned list is a list of IDs
    onChange: PropTypes.func, // returned list is a list of IDs
}



// WEBPACK FOOTER //
// ./src/ui/components/SortablePicker.js